<template>
    <div class="plugin-slider-mention-item swiper-slide">
        <div class="plugin-slider-mention-item__media">
            <img v-bind:src="image" alt="" />
        </div>
        <div class="plugin-slider-mention-item__content">
            <div class="plugin-slider-mention-item__content-icon">
                <icon name="quote" />
            </div>
            <div class="plugin-slider-mention-item__content-text" v-text="text" />
            <plugin-home-common-arrow-link
                v-bind:text="buttonText"
                v-bind:url="buttonUrl"
                theme="primary"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'plugin-slider-mention-item',
    props: {
        text: {
            type: String,
        },
        buttonText: {
            type: String,
        },
        buttonUrl: {
            type: String,
        },
        image: {
            type: String,
        },
    },
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-slider-mention-item {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 420px;
    height: 530px;

    border: 1px solid @color-gray-light-secondary;
    border-radius: @border-radius-xxl;

    background-color: white;
    overflow: hidden;

    &__media {
        width: 100%;
        height: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border-bottom: 1px solid @color-gray-light-secondary;
        img {
            height: 48px;
        }
    }
    &__content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 32px;
        background-color: #FCFAFA;
        overflow: hidden;
        &-icon {
            flex-shrink: 0;
            font-size: 3.6rem;
            color: @color-primary;
        }
        &-text {
            .typography-medium();

            height: 100%;
            overflow: auto;
        }
    }
    @media @media-md-down {
        max-width: 100%;
        height: 460px;
        border-radius: @border-radius-xxl;
        &__media {
            height: 120px;
        }
        &__content {
            padding: 32px 24px;
            &-title {
                .typography-small();
            }
            &-text {
                .typography-small();
            }
        }
    }
}
</style>
